import { FC, createContext, memo, useMemo, useState } from 'react';

import { ISplitFactoryChildProps, SplitFactoryProvider } from '@splitsoftware/splitio-react';

import { Loader } from '../../components/loader/Loader';
import { SplitContextControllerProps, SplitContextDispatch } from './SplitContextController.types';

export const SplitDispatchContext = createContext<SplitContextDispatch | undefined>(undefined);

export const SplitContextController: FC<SplitContextControllerProps> = memo(
  ({ attributes: defaultAttributes, children, customerKey, sdkKey, fallback }) => {
    const [attributes, setAttributes] = useState(defaultAttributes);

    const config: SplitIO.IBrowserSettings = useMemo(
      () => ({
        core: {
          authorizationKey: sdkKey,
          key: customerKey,
        },
      }),
      [customerKey, sdkKey],
    );

    return (
      <SplitDispatchContext.Provider value={setAttributes}>
        <SplitFactoryProvider config={config} updateOnSdkTimedout={true} attributes={attributes}>
          {({ isReady }: ISplitFactoryChildProps) => {
            if (!isReady) {
              return fallback ?? <Loader />;
            }

            return children;
          }}
        </SplitFactoryProvider>
      </SplitDispatchContext.Provider>
    );
  },
);
